module.exports = __webpack_public_path__ + "static/img/victoria2.cba0d5f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/victoria2.jpg
// module id = 148
// module chunks = 9